<template>
    <div class="header">
        <v-app-bar class="geodis" color="#3200e6" height="72" fixed>
            <div class="d-flex align-center">
                <img class="logo" src="@/assets/geodis/logo.png" />
                <h1 class="link-home">PASS Account</h1>
            </div>
            <v-spacer></v-spacer>
            <div>
                <div
                    class="actions d-flex align-center justify-center"
                    v-if="this.$store.state.user.informations && this.$store.state.user.informations.userInfo"
                >
                    <span class="help-account">
                        <v-icon
                            data-cy="helpButton"
                            class="initials"
                            color="white"
                            v-show="isInAModule()"
                            @click="openGuidePdf"
                            x-large
                        >
                            mdi-help-circle
                        </v-icon>
                        <v-icon v-show="!isPassAccount()" class="account" @click="goToPassAccount" x-large>
                            mdi-account-circle
                        </v-icon>
                    </span>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn elevation="0" color="#3200e6" class="user-menu fill-height" v-bind="attrs" v-on="on">
                                <span class="initials">
                                    {{
                                        $store.state.user.informations.userInfo.firstname.split('')[0] +
                                        $store.state.user.informations.userInfo.lastname.split('')[0]
                                    }}
                                </span>
                            </v-btn>
                        </template>
                        <v-list class="user-menu-list">
                            <v-list-item class="name" data-cy="fullName">
                                <v-list-item-title
                                    >{{ $store.getters.getUserInformations.userInfo.firstname }}
                                    {{ $store.getters.getUserInformations.userInfo.lastname }}</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-group
                                :value="false"
                                class="user-menu-list-languages"
                                no-action
                                @click="e => e.stopImmediatePropagation()"
                                prepend-icon="mdi-earth"
                            >
                                <template v-slot:activator>
                                    <v-list-item-title data-cy="languageMenu">Languages</v-list-item-title>
                                </template>
                                <v-list-item
                                    v-for="lang in locales"
                                    :key="lang.val"
                                    v-bind:class="{ selectedLanguage: currentLang === lang.val }"
                                >
                                    <v-list-item-title @click="setLocale(lang.val)">{{ lang.label }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-item v-if="authorization && authorization.superAdmin">
                                <v-list-item-icon>
                                    <v-icon>mdi-home</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-on:click="redirectToBackoffice()" data-cy="backOfficeMenu">
                                        Backoffice
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="this.$store.state.user.informations && this.$store.state.user.informations.userInfo">
                                <v-list-item-icon>
                                    <v-icon>mdi-logout</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title data-cy="headerUserMenuSignOut" v-on:click="signOut()">
                                        Sign-out
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <div class="buttons d-flex align-center" v-else-if="$route.path.startsWith('/accMgmt/Configuration')">
                    <v-select
                        color="#3200E6"
                        label="Languages"
                        :items="locales"
                        item-text="label"
                        @change="setLocale"
                        item-value="val"
                    ></v-select>
                </div>
                <div class="buttons d-flex align-center" v-else>
                    <v-btn v-on:click="ldapAuth()">Sign-in LDAP</v-btn>
                    <v-select
                        color="#3200E6"
                        label="Languages"
                        :items="locales"
                        item-text="label"
                        @change="setLocale"
                        item-value="val"
                        v-if="$route.path.startsWith('/password-lost')"
                    ></v-select>
                </div>
            </div>
        </v-app-bar>
        <v-app-bar class="breadcrumb" height="45" flat>
            <div class="links d-flex align-center" v-if="$route.path.startsWith('/accMgmt/Configuration')">
                <router-link class="home" to="/login"> Home </router-link>
                <div class="breadcrumb">
                    <v-icon x-large color="#3200e6">fas fa-chevron-right</v-icon>
                    <span class="page router-link-exact-active">
                        {{ $t('passAccount.configuration.breadcrumb') }}
                    </span>
                </div>
            </div>
            <div
                class="links d-flex align-center"
                v-if="!$route.path.includes('/password-lost') && !$route.path.startsWith('/accMgmt/Configuration')"
            >
                <router-link class="home" to="/"> Home </router-link>
                <div class="breadcrumb" v-if="breadCrumb.length > 0">
                    <span v-for="(element, index) in reducedBreadcrumb" :key="index">
                        <v-icon x-large color="#3200e6">fas fa-chevron-right</v-icon>
                        <router-link :to="element.url">
                            <span class="page">
                                {{ $t(element.label) }}
                            </span>
                        </router-link>
                    </span>
                </div>
            </div>
        </v-app-bar>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { parseCookies } from '@utils/cookie';
import { BREADCRUMB, NAVIGATION, ACCOUNT_MANAGEMENT_NAME } from '@constants/navigation';
import { ACLCONFIG, AUTHORIZATION } from '@constants/aclConfig';
import { api } from '@utils/api';
import { getCurrentModule } from '@utils/helpers';

export default {
    components: {},
    computed: {
        ...mapState(NAVIGATION, [BREADCRUMB, 'currentLang']),
        ...mapState(ACLCONFIG, [AUTHORIZATION]),
        reducedBreadcrumb() {
            return this.breadCrumb.slice(0, 2).filter(element => element && element.label);
        }
    },
    data() {
        return {
            locales: [
                { label: 'English', val: 'en' },
                { label: 'Francais', val: 'fr' }
            ],
            homepage: window.location.origin,
            guideResult: null
        };
    },
    methods: {
        ...mapMutations(NAVIGATION, ['selectLang']),
        ...mapMutations(['setUserInformations']),
        async setLocale(locale) {
            this.selectLang(locale);
            await api.setLang(locale, this.$i18n, this.$vuetify);
            await this.getGuide();
            if (window.OneTrust) {
                window.OneTrust.changeLanguage(locale);
            }
            if (
                !window.location.pathname.startsWith('/accMgmt/Configuration') &&
                !window.location.pathname.startsWith('/password-lost') &&
                !window.location.pathname.startsWith('/accMgmt/pwdConfiguration')
            ) {
                await this.getGuide();
            }
        },
        redirectToBackoffice: function () {
            this.$router.push('/backoffice');
        },
        async signOut() {
            await api.get('logout', null, { withCredentials: true }, 'admin');
            this.$session.destroy();
            this.setUserInformations(null);
            this.$router.push('/login');
        },
        ssoAuth: function () {
            this.$router.push('/login/sso');
        },
        ldapAuth: function () {
            this.$router.push('/login');
        },
        isConnected: function () {
            const connected = parseCookies('passToken', false);
            return connected;
        },
        isPassAccount() {
            return getCurrentModule() === ACCOUNT_MANAGEMENT_NAME;
        },
        isInAModule() {
            return !!getCurrentModule();
        },
        goToPassAccount() {
            this.$router.push('/accMgmt');
        },
        async getGuide() {
            this.guideResult = await api.get(
                'userGuides',
                null,
                { params: { lang: this.$i18n.locale, moduleName: ACCOUNT_MANAGEMENT_NAME } },
                'global'
            );
        },
        async openGuidePdf() {
            setTimeout(() => {
                if (this.guideResult) {
                    const pdfWindow = window.open('text/html');
                    pdfWindow.document.write(
                        '<head><title>' +
                            this.$i18n.t('navigations.userGuide') +
                            "</title></head><iframe width='100%' height='100%' src='data:application/pdf;base64," +
                            encodeURI(this.guideResult.content) +
                            "'></iframe>"
                    );
                    pdfWindow.document.close();
                }
            }, 1000);
        }
    },
    async mounted() {
        document.title = 'PASS Account';
        this.isConnected();
        if (
            !window.location.pathname.startsWith('/accMgmt/Configuration') &&
            !window.location.pathname.startsWith('/password-lost') &&
            !window.location.pathname.startsWith('/accMgmt/pwdConfiguration')
        ) {
            await this.getGuide();
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';
.v-list-item__title {
    cursor: pointer;
}
.help-account {
    position: relative;
    right: 8px;
}
header.geodis {
    .help,
    .custButton {
        font-size: 16px !important;
        text-transform: none !important;
        z-index: 2;
        color: white;
        background-color: #3200e6;
        border: none;
        cursor: pointer;
        height: 100% !important;
    }
    .account {
        font-size: 50px !important;
        z-index: 2;
        color: $primary;
        cursor: pointer;
        :focus {
            background-color: white;
        }
    }
    .logo {
        height: 50px;
    }
    h1 {
        font-weight: 400 !important;
        margin-left: 20px !important;
        font-size: 20px !important;
        color: white !important;
    }
    .user-menu {
        height: 100% !important;
        color: #f7f7f7;
        > * {
            color: $primary;
        }
        white-space: nowrap;
        text-transform: none;
        &:hover {
            background-color: none;
        }
        .initials {
            border-radius: 50%;
            border: 2px solid white;
            background-color: #3200e6;
            color: #f7f7f7;
            text-transform: uppercase;
            font-weight: 900 !important;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 59px;
            height: 57px;
        }
        .v-icon {
            margin-left: 5px;
        }
    }
}

.user-menu-list {
    .v-list-item__title {
        color: $primary;
        font-weight: 700;
        cursor: pointer;
    }
    .name {
        border-bottom: 1px solid #d5d5d5;
        .v-list-item__title {
            font-weight: 400;
        }
    }
    i {
        color: $primary !important;
    }
    .user-menu-list-languages {
        .v-list-group__items {
            .v-list-item {
                min-height: 30px;
                .v-list-item__title {
                    color: $primary-grey;
                    font-weight: 400;
                    min-height: 22px;
                }
            }
        }
    }
}

header.geodis {
    background-color: $primary !important;
    .links {
        font-size: 0.8em;
        .home {
            i {
                margin-right: 5px;
                margin-top: -3px;
            }
            &.router-link-exact-active {
                font-weight: 700;
            }
        }
        a,
        .page {
            text-decoration: none;
            color: #fff;
            padding: 0;
        }
        .breadcrumb {
            i {
                margin: 0 10px;
                font-size: 0.6em !important;
            }
            .router-link-exact-active {
                font-weight: 700;
            }
        }
    }
}

.language-item {
    cursor: pointer;
}

.buttons {
    button,
    .v-select {
        margin-left: 20px;
    }
    .v-select {
        width: 110px;
        .v-select__selections {
            padding: 0 !important;
        }
        .v-text-field__details {
            display: none;
        }
        .v-input__append-inner {
            margin: 0;
            align-self: center;
        }
        .v-input__slot {
            min-height: 0;
        }
        .v-input__control {
            min-height: auto !important;
        }
        .v-input__slot {
            margin-bottom: 0 !important;
        }
    }
}
.selectedLanguage {
    background-color: #3200e61e;
}

header.breadcrumb {
    display: flex;
    flex-direction: column;
    justify-content: flex-end; // ➜ Contenu en bas
    padding: 0 !important;
    transform: translateY(80px) !important;
    z-index: 8;
    background-color: #fff !important;

    .links {
        display: flex;
        align-items: center;
        font-size: 0.8em;

        .home {
            i {
                margin-right: 5px;
                margin-top: -5px;
            }

            &.router-link-exact-active {
                font-weight: 700;
            }
        }

        a,
        .page {
            text-decoration: none;
            padding: 0;
            color: $primary !important;
            font-weight: bold !important;
        }

        .breadcrumb {
            display: flex;
            align-items: center;

            span {
                display: flex;
                align-items: center;
            }

            i {
                margin: 0 10px;
                font-size: 0.6em !important;
            }

            a {
                display: flex;
                align-items: center;
            }

            .router-link-exact-active {
                font-weight: 700;
            }
        }
    }
}
</style>
